<template>
    <div class="submenu" :class="{ 'is-open': open }" :aria-hidden="!open">
        <Brands
            v-if="menuItem.type === 'brands'"
            :menu-item="menuItem"
            @close="$emit('close')"
            @select="$emit('close')"
        />
        <ul v-else class="submenu-list">
            <li>
                <button
                    type="button"
                    class="back-button"
                    @click="$emit('close')"
                >
                    <ChevronLeft class="mb-1" :size="24" :stroke-width="1.5" />
                    {{ menuItem.label }}
                </button>
            </li>
            <li v-for="child in visibleChildren" :key="child.label">
                <a
                    v-if="child.external"
                    :href="child.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    :class="navSubLinkClass"
                    @click="$emit('close')"
                >
                    {{ child.label }}
                </a>
                <span
                    v-else-if="child.href === '#'"
                    :class="['nav-void', navSubLinkClass]"
                >
                    {{ child.label }}
                </span>
                <router-link
                    v-else
                    :to="child.href"
                    :class="navSubLinkClass"
                    @click="$emit('close')"
                >
                    {{ child.label }}
                </router-link>
            </li>
        </ul>
        <div class="blank" @click="$emit('close')"></div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { ChevronLeft } from "lucide-vue";
import Brands from "./Brands.vue";
import { visibleMenuItems } from "./menuLinks";

const props = defineProps({
    menuItem: {
        type: Object,
        required: true,
    },
    open: {
        type: Boolean,
        default: false,
    },
});

const navSubLinkClass =
    "text-lg text-dark-grey font-normal py-2 flex items-center justify-between";
const visibleChildren = computed(() =>
    visibleMenuItems(props.menuItem.children)
);
</script>

<style lang="scss" scoped>
.submenu {
    background: none;
    display: flex;
    height: 100%;
    left: 0;
    opacity: 1;
    position: fixed;
    pointer-events: none;
    top: 0;
    visibility: hidden;
    width: 100%;
    z-index: 9999;
    transition: visibility 0s linear 300ms;

    .submenu-list {
        background: white;
        height: 100%;
        list-style: none;
        padding: 1rem;
        position: relative;
        max-width: none;
        transform: translateX(-100%);
        transition: transform 300ms ease;
        width: 480px;
        z-index: 1;

        .back-button {
            background: none;
            border: none;
            color: var(--color-dark-grey) !important;
            cursor: pointer;
            font-size: var(--font-size-lg) !important;
            font-weight: bold;
            margin: 1rem 0;
            padding: 0;
            text-align: left;
            text-transform: uppercase;
            width: 100%;
        }
    }

    .blank {
        backdrop-filter: blur(0);
        background: rgba(0, 0, 0, 0.6);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        opacity: 0;
        transition: backdrop-filter 300ms ease, opacity 300ms ease;
        width: 100%;
        z-index: 0;
    }

    &.is-open {
        pointer-events: auto;
        visibility: visible;
        transition-delay: 0s;

        .submenu-list {
            transform: translateX(0);
        }

        .blank {
            backdrop-filter: blur(5px);
            opacity: 1;
        }
    }
}

@media (max-width: 767px) {
    .submenu .submenu-list {
        width: 100%;
    }
}
</style>
